import { z } from 'zod';
import { SWAP_REASONS } from './types';

export const fieldReportSchema = z.object({
	poId: z.string().nonempty('Process object is required'),
	performedAt: z.date({ message: 'Date is required' }),
	deploymentTypeId: z.string().nonempty('Deployment type is required'),
	notes: z
		.string()
		.optional()
		.transform(s => s ?? ''),
	hasExternalAntennas: z.boolean().optional().default(false),
	swapReason: z.nativeEnum(SWAP_REASONS).nullable()
});

export type FieldReportFormSchema = z.infer<typeof fieldReportSchema>;
